<template>
  <div class="section-card recent-events-card">
    <div class="recent-events-header">
      <div class="recent-events-title-row">
        <div class="recent-events-icon-wrap" aria-hidden="true">
          <svg class="recent-events-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
            <path d="M12 7v5l3 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <h2 class="recent-events-heading">Recent Events</h2>
      </div>
      <div class="recent-events-segment" role="group" aria-label="Time range">
        <button
          type="button"
          class="recent-events-segment-btn"
          :class="{ active: selectedPeriod === '7d' }"
          @click="setPeriod('7d')"
        >7d</button>
        <button
          type="button"
          class="recent-events-segment-btn"
          :class="{ active: selectedPeriod === '30d' }"
          @click="setPeriod('30d')"
        >30d</button>
        <button
          type="button"
          class="recent-events-segment-btn"
          :class="{ active: selectedPeriod === '90d' }"
          @click="setPeriod('90d')"
        >90d</button>
      </div>
    </div>

    <div class="recent-events-list">
      <div
        v-for="(event, index) in filteredEvents"
        :key="index"
        class="recent-events-row"
      >
        <div class="recent-events-description">{{ event.title }}</div>
        <div class="recent-events-meta">{{ event.timeAgo }}</div>
      </div>
      <p v-if="!filteredEvents || filteredEvents.length === 0" class="recent-events-empty">No events in this period.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecentEvents',
  props: {
    events: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      selectedPeriod: '7d'
    }
  },
  computed: {
    daysToShow: function() {
      const periodMap = { '7d': 7, '30d': 30, '90d': 90 }
      return periodMap[this.selectedPeriod] || 7
    },
    filteredEvents: function() {
      return this.events || []
    }
  },
  methods: {
    setPeriod(period) {
      this.selectedPeriod = period
      this.$emit('period-changed', this.daysToShow)
    }
  }
}
</script>




// WEBPACK FOOTER //
// RecentEvents.vue?110070d2